import { getMonogramFromName } from 'util/participant';
import type * as CSS from 'csstype';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Participant, Track } from 'livekit-client';
import { useSIPParticipant, getNameFromMetadata } from 'useCase';

export enum OrientationEnum {
    Landscape = 'landscape',
    Portrait = 'portrait',
}

/** Имя без хука — для DataReceived / MobX reaction (snackbar модерации и вебинара). */
export const getParticipantDisplayName = (participant: Participant, unnamed: string): string => {
    return getNameFromMetadata(participant.metadata, unnamed);
};

export const useParticipantItem = () => {
    const { t } = useTranslation();
    const { checkIsSIPParticipant, getSIPParticipantName } = useSIPParticipant();

    const getDisplayData = useCallback(
        (participant: Participant, isLocal: boolean) => {
            const isSIPParticipant = checkIsSIPParticipant(participant);
            const name = isSIPParticipant
                ? getSIPParticipantName(participant)
                : getNameFromMetadata(participant.metadata, t('web_call_unnamed_user'));

            const placeholder = getMonogramFromName(name);
            const currentName = isLocal ? `${name} (${t('web_call_you_started')})` : name;

            return {
                currentName,
                name,
                placeholder,
            };
        },
        [t],
    );

    // when aspect matches, cover instead
    const getObjectFit = (desiredOrienation: OrientationEnum, videoDimensions?: Track.Dimensions) => {
        let objectFit: CSS.Properties['objectFit'] = 'contain';
        let videoOrientation: OrientationEnum | undefined;
        if (videoDimensions) {
            videoOrientation =
                videoDimensions.width > videoDimensions.height ? OrientationEnum.Landscape : OrientationEnum.Portrait;

            if (videoOrientation === desiredOrienation) {
                objectFit = 'cover';
            }
        }

        return objectFit;
    };

    return {
        getDisplayData,
        getObjectFit,
    };
};
